var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleTriangleDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:circle-triangle-up-fill",
    clipPath: "url(#clip0_7477_5968)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 541",
    cx: 8,
    cy: 8.33333,
    rx: 4,
    ry: 3.66667,
    transform: "rotate(-180 8 8.33333)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 15.334C12.0497 15.334 15.333 12.0507 15.333 8.00065C15.333 3.95065 12.0497 0.667317 7.99968 0.667317C3.94968 0.667316 0.666342 3.95065 0.666341 8.00065C0.666341 12.0506 3.94967 15.334 7.99967 15.334ZM10.133 6.66732C10.2276 6.66629 10.3208 6.69014 10.4033 6.73647C10.4858 6.78281 10.5547 6.85 10.603 6.93132C10.6485 7.01036 10.6702 7.10085 10.6654 7.19192C10.6607 7.28299 10.6298 7.37075 10.5763 7.44465L8.44301 10.4447C8.39191 10.5141 8.3251 10.5705 8.24805 10.6092C8.17101 10.6479 8.08589 10.6678 7.99967 10.6673C7.82101 10.6673 7.65501 10.584 7.55567 10.4447L5.42234 7.44465C5.36892 7.37075 5.33799 7.28298 5.33325 7.19192C5.32852 7.10085 5.3502 7.01036 5.39567 6.93132C5.44408 6.8499 5.51305 6.78264 5.59567 6.73631C5.67828 6.68997 5.77163 6.66618 5.86634 6.66732L10.133 6.66732Z",
    fill: "#9FA1A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7477_5968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTriangleDown);
export default __webpack_public_path__ + "static/media/circle-triangle-down.50f991e6a5f995b39a6c86d875acd6bf.svg";
export { ForwardRef as ReactComponent };